import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export const FRIEND_KEY = "cashmy_friend_token";

export default function FriendInvite() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const { data, error } = useQuery({ queryKey: ["friend-invite", token], queryFn: () => api.get(`/relatives/invite/${token}`).then((r) => r.data), retry: false });
  const accept = async () => {
    setBusy(true);
    try { const { data: r } = await api.post("/relatives/invite/accept", { token }); sessionStorage.removeItem(FRIEND_KEY); toast.success(`${r.name} est maintenant dans vos amis`); navigate("/proches", { replace: true }); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const remember = () => sessionStorage.setItem(FRIEND_KEY, token);
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6" data-testid="friend-invite-page">
      <div className="card-surface w-full max-w-md space-y-5 p-8 text-center fade-up">
        <div className="flex justify-center"><Logo size={44} /></div>
        {error ? <p className="text-sm text-destructive" data-testid="friend-invite-error">Ce lien d'invitation n'est plus valide. Demandez-en un nouveau à votre ami.</p>
          : !data ? <div className="h-24 animate-pulse rounded-2xl bg-muted" />
          : <>
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10"><UserPlus className="h-7 w-7 text-primary" /></div>
            <h1 className="text-2xl font-extrabold" data-testid="friend-invite-title">{data.name} vous invite sur CASHMY</h1>
            <p className="text-sm text-muted-foreground">Rejoignez sa liste d'amis pour organiser facilement cagnottes d'anniversaire, cadeaux communs et repas partagés. Vous apparaîtrez aussi dans la vôtre.</p>
            {user ? <Button className="h-11 w-full rounded-full" disabled={busy} onClick={accept} data-testid="friend-invite-accept">Ajouter {data.name} à mes amis</Button>
              : <div className="space-y-2">
                <Button className="h-11 w-full rounded-full" asChild><Link to={`/register?ami=${token}`} onClick={remember} data-testid="friend-invite-register">Créer mon compte gratuit</Link></Button>
                <Button variant="outline" className="h-11 w-full rounded-full" asChild><Link to="/login" onClick={remember} data-testid="friend-invite-login">J'ai déjà un compte</Link></Button>
              </div>}
          </>}
      </div>
    </main>
  );
}
